/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_ImprovementsInputs */

const en_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Areas for Improvement`)
};

const de_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbesserungsbereiche`)
};

const fr_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points à améliorer`)
};

const es_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áreas de mejora`)
};

const it_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aree di miglioramento`)
};

const nl_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbeterpunten`)
};

const pl_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obszary do poprawy`)
};

const fi_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehityskohteet`)
};

const da_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forbedringsområder`)
};

const sv_interview_practice_improvements = /** @type {(inputs: Interview_Practice_ImprovementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förbättringsområden`)
};

/**
* | output |
* | --- |
* | "Areas for Improvement" |
*
* @param {Interview_Practice_ImprovementsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_improvements = /** @type {((inputs?: Interview_Practice_ImprovementsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_ImprovementsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_improvements(inputs)
	if (locale === "fr") return fr_interview_practice_improvements(inputs)
	if (locale === "es") return es_interview_practice_improvements(inputs)
	if (locale === "it") return it_interview_practice_improvements(inputs)
	if (locale === "nl") return nl_interview_practice_improvements(inputs)
	if (locale === "pl") return pl_interview_practice_improvements(inputs)
	if (locale === "fi") return fi_interview_practice_improvements(inputs)
	if (locale === "da") return da_interview_practice_improvements(inputs)
	if (locale === "sv") return sv_interview_practice_improvements(inputs)
	return en_interview_practice_improvements(inputs)
});